<template>
  <div class="enfold">
    <div class="e-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
/**
 * 显示内容主界面
 * #使用方式
 * import subfield from '@/components/basics/Enfold'
 *  <enfold>
      <template>$内容主界面$</template> 
    </enfold>
 */
export default {

}
</script>

<style lang="scss" scoped>
.enfold {
  width: calc(100% - 24px);
  height: calc(100% - 24px);
  // 上线适配
  // max-height: 663px;
  padding: 12px;
  background: #edfbff;
  .e-content {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 8px;
    background: #fff;
  }
}
</style>